import React, { useState, useEffect } from "react";
import DashboardHeader from "../dashboard/DashboardHeader/DashboardHeader";
import CollapseBlock from "../dashboard/CollapseBlockLeft/collapseblockleft";
import CollapseBlockRight from "../dashboard/collapseblockright/collapseblockright";
import CustomSvg from "../svgs/CustomSvg";
import { useNavigate } from "react-router-dom";
import { useGames } from "../../utils/hooks";
import { Spinner } from "react-bootstrap";
import CustomErrorMsg from "../errorMsg/CustomErrorMsg";
import "./AllGames.css";
import ComingSoonModal from "../common/ComingSoonModal";

const API_URL = process.env.REACT_APP_API_SERVER_URL ;

// Helper to get background class for a game
const getGameBgClass = (game) => {
  const id = game.id || game._id || '';
  const title = (game.title || '').toLowerCase();
  if (id === "snooker" || title === "snooker") return "bg-[#73CD02]";
  if (id === "chess" || title === "chess") return "bg-[#2796CE]";
  if (id === "ludo" || title === "ludo") return "bg-[#FBBC04]";
  if (id === "whot" || title === "whot") return "bg-[#903A39]";
  if (id === "WordGame" || title === "WordGame") return "bg-[#EAD3AB]";
  return "bg-gray-100";
};


// Mobile game card
const MobileGameCard = ({ game, navigateTo, accountType, activeUsers }) => {
  // console.log(accountType)
  const navigate = useNavigate();
  const [showComingSoon, setShowComingSoon] = useState(false);
  const [comingSoonFeature, setComingSoonFeature] = useState("");

  const handleGameSelect = (game) => {
  if (game.title === "Snooker" || game.title === "Ludo") {
    setComingSoonFeature(`${game.title} Game`);
    setShowComingSoon(true);
  } else {
    if (accountType === "celebrity") {
      navigate(`/celebrity/host/${game.id}`);
    } else {
      navigate(`/games/selected-game/${game.id}`);
    }
  }
};

  const { bgClass, title, img, caption, arrowColor, id } = game;
  const stats = {
    rating: game.averageRating || 0,
    users: activeUsers || 0,
    avatars: game.avatars || [],
  };
  return (
    <div
      className={`rounded-xl py-2 px-3 cursor-pointer transition hover:scale-105 ${getGameBgClass(game)}`}
      onClick={() => handleGameSelect(game)}
    >
      <div className="flex flex-row h-30 gap-2 justify-between">
        {/* Image */}
        <div className="flex-none w-[60px] h-[60px] rounded-[10px] overflow-hidden mr-4 bg-white flex items-center justify-center">
          <img
            src={game?.img}
            alt={title}
            className="w-full h-full object-cover rounded-[10px]"
          />
        </div>

        <div>
          {/* Title + Rating */}
          <div className="flex justify-between items-start mb-2">
            <h4
              className={`text-lg text-capitalize font-bold ${
                id === "whot" ? "text-white" : "text-black"
              }`}
            >
              {game?.id}
            </h4>
            <div className="flex items-center space-x-1">
              {[...Array(5)].map((_, i) => (
                <span
                  key={i}
                  className={`text-xs ${
                    i < Math.round(stats.rating)
                      ? "text-yellow-400"
                      : "text-gray-400"
                  }`}
                >
                  ★
                </span>
              ))}
              <span className="text-xs text-white">{stats.rating}</span>
            </div>
          </div>

          {/* Caption */}
          <p
            className={`text-sm mb-2 ${
              id === "whot" ? "text-white" : "text-black"
            }`}
          >
            {caption}
          </p>

          {/* Bottom Row */}
          <div className="flex items-center justify-between relative">
            <div className="flex -space-x-3">
              {stats?.avatars?.map((user, i) => (
                <img
                  key={i}
                  src={user?.profile}
                  alt={user?.name}
                  className="w-8 h-8 rounded-full border-2 border-white"
                  style={{ zIndex: 10 - i }}
                />
              ))}
            </div>
            <span className="text-sm text-white whitespace-nowrap">
              +{stats.users} users
            </span>
            <span className="text-white">
              <CustomSvg
                name="arrow-right"
                width={18}
                height={18}
                color="white"
              />
            </span>
          </div>
        </div>
      </div>
      {/* Coming Soon Modal */}
      <ComingSoonModal
        show={showComingSoon}
        onHide={() => setShowComingSoon(false)}
        feature={comingSoonFeature}
      />
    </div>
  );
};

export default function AllGames({accountType}) {
  const navigate = useNavigate();
  const navigateTo = (path) => navigate(path);
  const [isLeftBlockOpen, setIsLeftBlockOpen] = useState(true);
  const [isRightBlockOpen, setIsRightBlockOpen] = useState(true);
  const [blocksOpen, setBlocksOpen] = useState("both");
  const [errorMsg, setErrorMsg] = useState(null);

  const { games, getGames } = useGames();
  const [activeUsersMap, setActiveUsersMap] = useState({});

  useEffect(() => {
    if (games && games.length > 0) {
      games.forEach(async (game) => {
        try {
          const res = await fetch(
            `${API_URL}active-users-in-game/${game._id}`
          );
          const data = await res.json();
          setActiveUsersMap((prev) => ({ ...prev, [game._id]: data.activeUsers || 0 }));
        } catch (e) {
          setActiveUsersMap((prev) => ({ ...prev, [game._id]: 0 }));
        }
      });
    }
  }, [games]);

  const [showComingSoon, setShowComingSoon] = useState(false);
  const [comingSoonFeature, setComingSoonFeature] = useState("");

  const handleGameSelect = (game) => {
    // Check if the game is Snooker or Ludo
    if (game.title === "Snooker" || game.title === "Ludo") {
      setComingSoonFeature(`${game.title} Game`);
      setShowComingSoon(true);
    } else {
      navigate(`/games/selected-game/${game.id}`);
    }
  };

  // Responsive: show mobile layout if window width <= 768px
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isLeftBlockOpen && isRightBlockOpen) {
      setBlocksOpen("both");
    } else if (!isLeftBlockOpen && !isRightBlockOpen) {
      setBlocksOpen("none");
    } else {
      setBlocksOpen("one");
    }
  }, [isLeftBlockOpen, isRightBlockOpen]);

  useEffect(() => {
    setErrorMsg(null);
    const get = async () => {
      try {
        await getGames();
      } catch (error) {
        // console.error(error);
        setErrorMsg(error.message || "Error loading available games");
      }
    };
    get();
  }, []);

  const getMainContentClass = () => {
    switch (blocksOpen) {
      case "both":
        return "col-lg-8 col-md-8 col-10 align-items-center justify-content-center";
      case "one":
        return "col-lg-9 col-md-9 px-lg-4 px-md-4 px-0 col-10 align-items-center justify-content-center";
      case "none":
        return "col-lg-10 col-md-10 px-lg-4 px-md-4 px-0 col-10 align-items-center justify-content-center";
      default:
        return "";
    }
  };

  const getGridClass = () => {
    switch (blocksOpen) {
      case "both":
        return "games-grid--both-open";
      case "one":
        return "games-grid--one-open";
      case "none":
        return "games-grid--none-open";
      default:
        return "";
    }
  };

  const renderGameCard = (game) => (
    <div
      key={game._id}
      onClick={() => handleGameSelect(game)}
      className={`rounded-2xl p-4 cursor-pointer transition-shadow hover:shadow-lg ${getGameBgClass(game)}`}
    >
      <div className="mb-4">
        <img
          src={game.img}
          alt={game.title}
          className="w-full h-40 object-cover rounded-xl"
        />
      </div>
      <div className="flex items-center justify-between">
        <div>
          <h4 className="text-lg font-semibold text-white">{game.title}</h4>
          <p className="text-sm text-white/80">{game.caption}</p>
        </div>
        <div className="flex items-center justify-center">
          <CustomSvg color={game.arrowColor} name="arrow-right" width={12} height={12} />
        </div>
      </div>
      <div className="flex items-center mt-2">
        {[...Array(5)].map((_, i) => (
          <span
            key={i}
            className={`text-xs ${i < Math.round(game.averageRating || 0) ? "text-yellow-400" : "text-gray-400"}`}
          >
            ★
          </span>
        ))}
        <span className="text-xs text-white ml-2">{game.averageRating ? game.averageRating.toFixed(1) : '0.0'}</span>
        <span className="text-xs text-white ml-4">| {activeUsersMap[game._id] || 0} users</span>
      </div>
    </div>
  );


  return (
    <div className="w-full min-h-screen bg-[#130828]">
      {/* Header for Desktop */}
      <div className="">
        <DashboardHeader />
      </div>

      <div className="w-full">
        {/* Mobile Layout */}
        {isMobile ? (
          <div className="px-4 py-6">
            <div className="mb-6">
              <h1 className="text-2xl font-bold text-white">
                All <span className={accountType === "celebrity" ? "text-[#3F9217]" : "text-pink-500"}>Games</span>
              </h1>
            </div>

            {games && games.length > 0 ? (
              <div className="space-y-4">
                {games.map((game) => (
                  <MobileGameCard
                    key={game._id}
                    game={game}
                    navigateTo={navigateTo}
                    accountType={accountType}
                  />
                ))}
              </div>
            ) : errorMsg ? (
              <div className="py-8">
                <CustomErrorMsg errorMsg={errorMsg} verticalPadding />
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center py-8 text-white">
                <p className="mb-2">Loading games...</p>
                <Spinner size="sm" variant="light" />
              </div>
            )}
          </div>
        ) : (
          <div className="flex w-full">
            {/* Left Sidebar */}
            <div
              className={`hidden md:flex ${
                isLeftBlockOpen ? "w-1/6" : "w-1/12"
              }`}
            >
              <CollapseBlock setIsLeftBlockOpen={setIsLeftBlockOpen} />
            </div>

            {/* Main Content */}
            <div
              className={`flex-1 px-4 md:px-6 py-6 transition-all duration-300`}
            >
              {/* Top Mobile Controls */}
              <div className="md:hidden flex items-center justify-between mb-6 w-full">
                <div className="w-1/2">
                  <CollapseBlock isSmallScreen />
                </div>
              </div>

              <div className="mb-6">
                <h1 className="text-2xl font-bold text-white">
                  Select <span className="text-pink-500">Game</span>
                </h1>
                <p className="text-sm text-gray-300 mt-1">
                  Select any game of your choice that you will like to
                  participate in
                </p>
              </div>

              {games && games.length > 0 ? (
                <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                  {games.map((game) => renderGameCard(game))}
                </div>
              ) : errorMsg ? (
                <div className="py-8">
                  <CustomErrorMsg errorMsg={errorMsg} verticalPadding />
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center py-8 text-white">
                  <p className="mb-2">Loading games...</p>
                  <Spinner size="sm" variant="light" />
                </div>
              )}
            </div>

            {/* Right Sidebar */}
            <div
              className={`hidden md:flex items-center justify-end ${
                isRightBlockOpen ? "w-1/6" : "w-1/12"
              }`}
            >
              <CollapseBlockRight setIsRightBlockOpen={setIsRightBlockOpen} />
            </div>
          </div>
        )}
      </div>

      {/* Bottom Mobile Controls */}
      {!isMobile && (
        <div className="md:hidden flex items-center justify-between w-full mt-4">
          <div className="w-1/2">
            <CollapseBlockRight isSmallScreen />
          </div>
        </div>
      )}

      <ComingSoonModal
        show={showComingSoon}
        onHide={() => setShowComingSoon(false)}
        feature={comingSoonFeature}
      />
    </div>
  );
}
